import React from 'react';
import { observer, inject } from 'mobx-react';

import Modal from 'js/components/core/Modal';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';
import StepMessage from 'js/components/core/SteppedPage/StepMessage';
import Title from 'js/components/core/SteppedPage/Title';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import Summary from './Summary';
import Delivery from './Delivery';
import Payment from './Payment';
import Shipping from './Shipping';

const modal = {
  delivery: Delivery,
  payment: Payment,
  shipping: Shipping,
};

export default inject('page')(
  observer(({ page }) => {
    const ModalContent = modal[page.modalDisplay];
    const showingShipping = page.modalDisplay === 'shipping';
    return (
      <>
        <Backdrop offset="1.75rem">
          <Constraint>
            <Title>Review order</Title>
            <SubTitle>Make sure this information is correct.</SubTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset="1.75rem">
          <Summary />

          <ProgressRow>
            <ContinueButton onClick={page.nextStep} />
          </ProgressRow>

          <StepMessage>You won't be charged until you confirm receiving your item.</StepMessage>
        </Constraint>

        <Modal
          showModal={page.modalIsVisible}
          onCancel={!showingShipping || page.shipping_service ? page.closeModal : null}
          withCloseButton={!showingShipping}>
          {ModalContent ? <ModalContent /> : null}
        </Modal>
      </>
    );
  }),
);
